import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './WageEditScreen';
import WageEdit from './WageEditScreen';
import { StoreState } from 'src/store/reducers';
import { getWage } from 'src/store/actions/wage-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { formValueSelector } from 'redux-form';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    const selector = formValueSelector('wage-form');
    const providerDropdown = selector(state, 'providerDropDown');
    return {
        providerSelect: providerDropdown?.value,
        wage: state.wages.current,
        inProgress: state.wages.inProgress,
        providers: selectNameProviders(state),
        inProgressProvider: state.providers.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getWage(id)),
        getProviders: (params) => dispatch(getProvidersSmall(params)),
    };
}

const WageEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(WageEdit);

export default WageEditScreen;
